export default __webpack_public_path__ + "static/media/logo-finanzas.09c636ca.png";